<template>
  <osr-status-intro />
  <osr-occurrence-map-sub-section />
  <osr-hf-map-sub-section />
  <osr-sector-effect-chart-sub-section/>
</template>
<script>
import { reactive, watch } from 'vue';
import { useApp } from '@/composables/state/profileState';

import OSRStatusIntro from './OSRStatusIntro.vue';
import OSROccurrenceMapSubSection from './OSROccurrenceMapSubSection.vue';
import OSRHFMapSubSection from './OSRHFMapSubSection.vue';
import OSRSectorEffectChartSubSection from './OSRSectorEffectChartSubSection.vue';
export default {
  components: {
    'osr-status-intro': OSRStatusIntro,
    'osr-occurrence-map-sub-section': OSROccurrenceMapSubSection,
    'osr-hf-map-sub-section': OSRHFMapSubSection,
    'osr-sector-effect-chart-sub-section': OSRSectorEffectChartSubSection
  },
  name: 'osr-bird-tab',

  setup (props) {

  }
}
</script>
